import type { ProfileDto } from '../../api/know'

/**
 * Etiquetas humanas para los enums que devuelve `/know/me/profile/options`.
 * El backend tiene su propio mapeo en `services/profile_completion.py`
 * (labels_es); acá replicamos para la UI. Vive suelto (y no dentro de
 * `KnowProfile`) porque lo consumen dos superficies: el wizard editor y el
 * header de perfil de `KnowHome`.
 */
export const GENDER_LABELS: Record<string, string> = {
  masculino: 'Masculino',
  femenino: 'Femenino',
  otro: 'Otro / no binario',
  prefiero_no_decir: 'Prefiero no decir',
}

export const POSITION_LABELS: Record<string, string> = {
  arquero: 'Arquero',
  defensor: 'Defensor',
  mediocampista: 'Mediocampista',
  delantero: 'Delantero',
  no_juego: 'No juego en equipo',
}

export const VR_EXPERIENCE_LABELS: Record<string, string> = {
  ninguna: 'Nunca usé VR',
  alguna: 'Probé alguna vez',
  regular: 'Uso VR regularmente',
}

export function labelOf(
  value: string | null,
  labels: Record<string, string>,
): string {
  return value ? labels[value] ?? value : '—'
}

export function footLabel(value: ProfileDto['dominant_foot']): string {
  if (value === 'right') return 'Derecho'
  if (value === 'left') return 'Izquierdo'
  if (value === 'both') return 'Ambos'
  return '—'
}
